import { IBusinessCase } from '../business-case/types';
import afcWimbledonBackgroundX1 from './assets/background-afc@1x.jpg';
import afcWimbledonBackgroundX2 from './assets/background-afc@2x.jpg';
import avalancheBackgroundX1 from './assets/background-avalanche@1x.png';
import avalancheBackgroundX2 from './assets/background-avalanche@2x.png';
import beaconsBackgroundX1 from './assets/background-beacons@1x.jpg';
import beaconsBackgroundX2 from './assets/background-beacons@2x.jpg';
import bobbieBackgroundX1 from './assets/background-bobbie@1x.jpg';
import bobbieBackgroundX2 from './assets/background-bobbie@2x.jpg';
import cartaBackgroundX1 from './assets/background-carta@1x.jpg';
import cartaBackgroundX2 from './assets/background-carta@2x.jpg';
import feminvestBackgroundX1 from './assets/background-feminvest@1x.jpg';
import feminvestBackgroundX2 from './assets/background-feminvest@2x.jpg';
import fireflyBackgroundX1 from './assets/background-firefly@1x.jpg';
import fireflyBackgroundX2 from './assets/background-firefly@2x.jpg';
import gumroadBackgroundX1 from './assets/background-gumroad@1x.png';
import gumroadBackgroundX2 from './assets/background-gumroad@2x.png';
import mavenBackgroundX1 from './assets/background-maven@1x.jpg';
import mavenBackgroundX2 from './assets/background-maven@2x.jpg';
import revolutBackgroundX1 from './assets/background-revolut@1x.jpg';
import revolutBackgroundX2 from './assets/background-revolut@2x.jpg';
import starAtlasBackgroundX1 from './assets/background-staratlas@1x.jpg';
import starAtlasBackgroundX2 from './assets/background-staratlas@2x.jpg';
import truthArtsBackgroundX1 from './assets/background-trutharts@1x.jpg';
import truthArtsBackgroundX2 from './assets/background-trutharts@2x.jpg';
import afcWimbledonLogo from './assets/logo-afc.png';
import logoAndreessenHorowitz from './assets/logo-andreessen-horowitz.png';
import avalancheLogo from './assets/logo-avalanche.png';
import beaconsLogo from './assets/logo-beacons.png';
import bobbieLogo from './assets/logo-bobbie.png';
import cartaLogo from './assets/logo-carta.png';
import feminvestLogo from './assets/logo-feminvest.png';
import fireflyLogo from './assets/logo-firefly.png';
import logoFirstRound from './assets/logo-first-round.png';
import logoGroundforceCapital from './assets/logo-groundforce.png';
import gumroadLogo from './assets/logo-gumroad.png';
import mavenLogo from './assets/logo-maven.png';
import revolutLogo from './assets/logo-revolut.png';
import logoSoftBank from './assets/logo-softbank.png';
import starAtlasLogo from './assets/logo-staratlas.png';
import truthArtsLogo from './assets/logo-trutharts.png';
import logoVMG from './assets/logo-vmg.png';
import logoYCombinator from './assets/logo-y-combinator.png';

export const BUSINESS_CASES: IBusinessCase[] = [
  {
    company: 'Avalanche',
    categories: ['Web3 Advisory', 'Token Design'],
    title:
      'Avalanche’s rapid ascent culminated in a $42 million public token offering',
    variant: 'dark',
    logoImage: avalancheLogo,
    backgroundImage: {
      url: avalancheBackgroundX1,
      url2x: avalancheBackgroundX2,
    },
    backgroundColor: '#3E1212',
  },
  {
    company: 'Carta',
    categories: ['Series F', 'Series G'],
    variant: 'light',
    title:
      'Carta partnered with Republic to provide superior cap table management',
    logoImage: cartaLogo,
    backgroundImage: {
      url: cartaBackgroundX1,
      url2x: cartaBackgroundX2,
    },
    backgroundColor: '#E4E4C8',
  },
  {
    company: 'Gumroad',
    categories: ['Community funding', 'Reg CF'],
    variant: 'light',
    title:
      'Gumroad was the first business to reach $5M raised under the SEC’s new rule limit',
    facts: [
      {
        value: '7,331',
        description: 'Investors',
      },
      {
        value: '$5M',
        description: 'Raised',
      },
    ],
    logoImage: gumroadLogo,
    backgroundImage: {
      url: gumroadBackgroundX1,
      url2x: gumroadBackgroundX2,
    },
    backgroundColor: '#C779B7',
  },
  {
    company: 'Firefly',
    categories: ['Series A', 'Series B', 'Series G'],
    title:
      'Firefly was the first private ground-based system to launch a rocket into orbit',
    variant: 'dark',
    logoImage: fireflyLogo,
    backgroundImage: {
      url: fireflyBackgroundX1,
      url2x: fireflyBackgroundX2,
    },
    backgroundColor: '#000000',
  },
  {
    company: 'Star Atlas',
    categories: ['Web3 advisory', 'Token Design'],
    title:
      'Star Atlas architected a galactic metaverse monetary policy and tokenomics',
    variant: 'dark',
    logoImage: starAtlasLogo,
    backgroundImage: {
      url: starAtlasBackgroundX1,
      url2x: starAtlasBackgroundX2,
    },
    backgroundColor: '#131313',
  },
  {
    company: 'Truth Arts',
    categories: ['Sharedops™'],
    title:
      'Truth Arts revolutionizes NFTs by distributing $5M in free equity to holders',
    variant: 'dark',
    logoImage: truthArtsLogo,
    backgroundImage: {
      url: truthArtsBackgroundX1,
      url2x: truthArtsBackgroundX2,
    },
    backgroundColor: '#821012',
  },
  {
    company: 'AFC Wimbledon',
    categories: ['Community funding', 'Reg D'],
    title: 'AFC Wimbledon raised £2.4M on Republic to build a new stadium',
    variant: 'dark',
    facts: [
      {
        value: '5,070',
        description: 'Investors',
      },
      {
        value: '£3.9M+',
        description: 'Raised',
      },
    ],
    logoImage: afcWimbledonLogo,
    backgroundImage: {
      url: afcWimbledonBackgroundX1,
      url2x: afcWimbledonBackgroundX2,
    },
    backgroundColor: '#000000',
  },
  {
    company: 'Revolut',
    categories: ['Community funding'],
    variant: 'dark',
    title: 'Revolut propelled Republic  investors to over 5,000% growth',
    facts: [
      {
        value: '3,516',
        description: 'Investors',
      },
      {
        value: '£3.8M',
        description: 'Raised',
      },
    ],
    backedBy: [
      {
        name: 'SoftBank',
        logo: logoSoftBank,
      },
      {
        name: 'GroundForce Capital',
        logo: logoGroundforceCapital,
      },
    ],
    logoImage: revolutLogo,
    backgroundImage: {
      url: revolutBackgroundX1,
      url2x: revolutBackgroundX2,
    },
    backgroundColor: '#000000',
  },
  {
    company: 'Feminvest',
    categories: ['Community funding'],
    title:
      'Feminvest engaged the over 1,500+ female investors to raised $1M under 4 minutes',
    variant: 'light',
    facts: [
      {
        value: '87.5%',
        description: 'Female investors',
      },
      {
        value: '$1M',
        description: 'Raised',
      },
    ],
    logoImage: feminvestLogo,
    backgroundImage: {
      url: feminvestBackgroundX1,
      url2x: feminvestBackgroundX2,
    },
    backgroundColor: '#D0CBC9',
  },
  {
    company: 'Bobbie',
    categories: ['Community funding', 'Reg CF'],
    title:
      'Bobbie invited their earliest customers to invest in the Series A round',
    variant: 'dark',
    backedBy: [
      {
        name: 'VMG',
        logo: logoVMG,
      },
    ],
    logoImage: bobbieLogo,
    backgroundImage: {
      url: bobbieBackgroundX1,
      url2x: bobbieBackgroundX2,
    },
    backgroundColor: '#7FC7A3',
  },
  {
    company: 'Maven',
    categories: ['Community funding', 'Reg CF'],
    title:
      'Maven raises $20M Series A led by a16z after $750K Reg CF campaign on Republic',
    backedBy: [
      {
        name: 'Andreessen Horowitz',
        logo: logoAndreessenHorowitz,
      },
      {
        name: 'First Round',
        logo: logoFirstRound,
      },
    ],
    variant: 'dark',
    logoImage: mavenLogo,
    backgroundImage: {
      url: mavenBackgroundX1,
      url2x: mavenBackgroundX2,
    },
    backgroundColor: '#022107',
  },
  {
    company: 'Beacons',
    categories: ['Community funding', 'Reg D'],
    title: 'Beacons helps creators monetize with AI tools',
    facts: [
      {
        value: '185',
        description: 'Investors',
      },
      {
        value: '$200k',
        description: 'Raised',
      },
    ],
    backedBy: [
      {
        name: 'Andreessen Horowitz',
        logo: logoAndreessenHorowitz,
      },
      {
        name: 'Y Combinator',
        logo: logoYCombinator,
      },
    ],
    variant: 'light',
    logoImage: beaconsLogo,
    backgroundImage: {
      url: beaconsBackgroundX1,
      url2x: beaconsBackgroundX2,
    },
    backgroundColor: '#CED2FB',
  },
];
